import React, { useState } from "react";
import InputField from "../forms/input-field";
import { useFormikContext } from "formik";

const Checkbox = ({ label, onChange, checked ,disabled}) => (
  <div className="flex flex-row w-full items-center gap-2" key={label}>
    <input
      type="checkbox"
      className="custom-checkbox form-check-input ml-[3px]"
      onChange={onChange}
      checked={checked}
      disabled={disabled}
    />
    <label className="text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-variable-fw)]">
      {label}
    </label>
  </div>
);

function Recipients({ groups, users, activeTab, disabled, heightOfSecondDiv }) {
  const { values, setFieldValue } = useFormikContext();
  if (activeTab === "") return null;
  let type;
  if (activeTab === "Email") {
    type = "email";
  } else if (activeTab === "SMS") {
    type = "sms";
  } else if (activeTab === "WhatsApp") {
    type = "whatsapp";
  } else if (activeTab === "Push Notification") {
    type = "push_notification";
  }
  // const handleGroupChange = (groupName) => {
  //   setSelectedGroups((prev) =>
  //     prev.includes(groupName)
  //       ? prev.filter((g) => g !== groupName)
  //       : [...prev, groupName]
  //   );
  // };
  const selectedGroups =
    values.notificationRecipientsData[type]?.recipient_group;
  const selectedUserIds =
    values.notificationRecipientsData[type]?.recipient_users;

  const handleToggleGroup = (groupName) => {
    if (disabled) return;
    const selectedGroups =
      values.notificationRecipientsData[type]?.recipient_group;

    const updatedGroups = selectedGroups.includes(groupName)
      ? selectedGroups.filter((g) => g !== groupName) // remove
      : [...selectedGroups, groupName]; // add

    setFieldValue(
      `notificationRecipientsData[${type}].recipient_group`,
      updatedGroups
    );
  };

  const visibleUsers = users.filter((user) =>
    selectedGroups.includes(user.group)
  );

  const handleToggleUser = (user_id) => {
    if (disabled) return;

    const updatedUserIds = selectedUserIds.includes(user_id)
      ? selectedUserIds.filter((id) => id !== user_id) // remove
      : [...selectedUserIds, user_id]; // add

    setFieldValue(
      `notificationRecipientsData[${type}].recipient_users`,
      updatedUserIds
    );
  };

  return (
    <div
      style={{
        maxHeight: `${heightOfSecondDiv}px`,
        height: `${heightOfSecondDiv}px`,
      }}
      className="tab-container overflow-y-auto  flex grow basis-[27%] flex-col border p-[25px] rounded-[var(--alert-management-border-radius)] border-[var(--alert-management-border-color)]"
    >
      <div className="flex flex-col gap-[30px]">
        <label className="text-[length:var(--alert-management-title-fs)] font-[var(--alert-management-title-fw)]">
          Recipients
        </label>

        <div className="flex flex-col gap-6">
          {/* Groups */}
          <div className="flex flex-col gap-2">
            <label className="text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full">
              Select Groups
            </label>
            <div className="flex flex-col gap-2">
              {groups?.map((group, i) => (
                <Checkbox
                  key={group.name}
                  label={group.name}
                  checked={values.notificationRecipientsData[
                    type
                  ]?.recipient_group?.includes(group.name)}
                  onChange={() => handleToggleGroup(group.name)}
                  disabled={disabled}
                />
              ))}
            </div>
          </div>

          {/* Users */}
          {/* {selectedGroups.length > 0 && ( */}
          <div className="flex flex-col gap-2">
            <label className="text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full">
              Select Users
            </label>
            <div className="flex flex-col gap-2">
              {visibleUsers.map((user) => (
                <Checkbox
                  key={user.user_id}
                  label={user.user_name}
                  checked={selectedUserIds.includes(user.user_id)}
                  onChange={() => handleToggleUser(user.user_id)}
                  disabled={disabled}

                />
              ))}
            </div>
          </div>
          {/* )} */}

          <InputField
            key={`notificationRecipientsData[${type}].specific_users[${0}]`}
            onKeyDown={() => {}}
            errMsgContainerClass="hidden"
            labelClass="text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full"
            parentClass="flex flex-col gap-2 w-full align-end"
            name={`notificationRecipientsData[${type}].specific_users[${0}]`}
            defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
            placeholder="Enter Email"
            label="Custom Recipients"
            isDisabled={disabled}
            containerClass="w-full h-min"
            type="text"
          />
        </div>
      </div>
    </div>
  );
}

export default Recipients;
